import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BankAccountsListGroupedByInstitutionData } from '../../bank/bank.model';
import { BrokerData } from '../broker.model';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { readWrite } from '../../user/user-permission/user-permission.data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-broker-bank-account-list',
    templateUrl: './broker-bank-account-list.component.html',
    styleUrls: ['./broker-bank-account-list.component.scss'],
    standalone: false
})
export class BrokerBankAccountListComponent implements OnInit {

  canReadWriteBank: boolean;

  constructor(
    private userPermissionService: UserPermissionService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe(this.dataInit.bind(this));

    this.userPermissionService.granted([readWrite('servicing-bank-accounts')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.canReadWriteBank = res);
  }

  data: BrokerBankAccountListComponentData;

  dataInit(data: BrokerBankAccountListComponentData) {
    this.data = data;
  }

  addBankAccountLink() {
    this.router.navigate([`broker/${this.data.broker.id}/banks/new`]);
  }
}

export interface BrokerBankAccountListComponentData {
  bankAccountsListGroupedByInstitution?: BankAccountsListGroupedByInstitutionData[];
  broker?: BrokerData;
}
